var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"color__icon-MX",style:('font-size:' + _vm.fontSize + 'px'),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#color-icon_' + _vm.iconName}})])}
var staticRenderFns = []

export { render, staticRenderFns }